import { validateCPF } from "@/lib/custom-validations"
import z from "zod"

export const contractSchema = z.object({
  // Referência ao projeto
  movieId: z.number().int().positive("ID do projeto deve ser positivo"),

  // Dados da pessoa/empresa (preenchidos via select de busca)
  personId: z.string().optional(),
  email: z.string().email("Selecione uma pessoa/empresa válida").min(1, "Selecione uma pessoa/empresa"),
  name: z.string().min(1, "Selecione uma pessoa/empresa"),
  document: z.string().min(11, "CPF deve ter 11 dígitos").refine(
    (value) => {
      const clean = value.replace(/\D/g, "")
      return clean.length === 11 && validateCPF(clean)
    },
    { message: "CPF inválido" }
  ),
  role: z.string().optional(),

  // Campos obrigatórios do contrato
  contract_description: z.string().optional().default(""),
  contract_till: z.date().or(z.string().min(1, "Data de término obrigatória")),
  total_amount: z.string().min(1, "Valor total obrigatório"),

  // Campos opcionais
  uploaded_contract_url: z.string().optional(),
  contract_start: z.date().or(z.string()).optional(),
  signature_date: z.date().or(z.string()).optional(),
  payment_method: z.string().optional(),
  location: z.string().optional(),
  month_amount: z.string().optional(),
  amount_paid_till_now: z.string().optional(),
  active: z.boolean().optional().default(true),

  // Testemunhas
  id_testment_one: z.number().int().positive().optional(),
  id_testment_two: z.number().int().positive().optional(),

  // Direitos autorais
  has_copyright: z.string().optional().default("false"),
  copyright_type: z.enum(["PATRIMONIAL", "MORAL", "BOTH"]).optional(),
  rlp_participation_percent: z.string().optional(),
  credits_attribution: z.string().optional(),
  biblioteca_nacional_reg: z.string().optional(),

  // Dados fiscais (ANCINE)
  cnae_codes: z.string().optional(),
  service_code: z.string().optional(),
  drt_number: z.string().optional(),
  cane_registration: z.string().optional(),
})

export type ContractFormData = z.infer<typeof contractSchema>